import React, { useState, lazy, Suspense, useCallback } from "react";
import { connect } from "react-redux";
import { Spinner } from "react-bootstrap";
import PageHeader from "components/layout/page-header/PageHeader";
import LogsDashboard from "pages/admin/LogsDashboard";
import UsersDashboard from "pages/admin/UsersDashboard";
import TrialInsightsPanel from "pages/admin/TrialInsightsPanel";
import styles from "./AdminDashboards.module.css";

const ExecutiveDashboard = lazy(() => import("pages/admin/ExecutiveDashboard"));
const CustomerDashboard = lazy(() => import("pages/admin/CustomerDashboard"));
const SecurityDashboard = lazy(() => import("pages/admin/SecurityDashboard"));
const ProductDashboard = lazy(() => import("pages/admin/ProductDashboard"));

const TABS = [
  { key: "overview",  label: "Overview",    icon: "fas fa-tachometer-alt" },
  { key: "logs",      label: "Sistema",     icon: "fas fa-server"         },
  { key: "users",     label: "Usuários",    icon: "fas fa-users"          },
  { key: "customers", label: "Clientes",    icon: "fas fa-user-chart"     },
  { key: "security",  label: "Segurança",   icon: "fas fa-shield-alt"     },
  { key: "product",   label: "Produto",     icon: "fas fa-cubes"          },
];

const Fallback = () => (
  <div className={styles.fallback}>
    <Spinner animation="border" size="sm" style={{ color: "#035184" }} />
    <span>Carregando...</span>
  </div>
);

const RIBBON_TO_FILTER = {
  total: "all",
  critical: "critical",
  warning: "warning",
  d2: "d2_pending",
  week: "week"
};

function AdminDashboards({ token }) {
  const [activeKey, setActiveKey] = useState("overview");
  const [usersTrialFilter, setUsersTrialFilter] = useState(null);
  const [filterNonce, setFilterNonce] = useState(0);

  const handleRibbonKpi = useCallback(k => {
    setUsersTrialFilter(RIBBON_TO_FILTER[k] || "all");
    setFilterNonce(n => n + 1);
    setActiveKey("users");
  }, []);

  return (
    <div className={styles.pageContainer}>
      <PageHeader
        title="Dashboards"
        subtitle="Observabilidade, analytics e métricas da plataforma."
        accent="Administração"
      />

      {token && (
        <TrialInsightsPanel
          token={token}
          variant="ribbon"
          onRibbonKpiClick={handleRibbonKpi}
        />
      )}

      <div className={styles.tabBar}>
        {TABS.map(tab => (
          <button
            key={tab.key}
            type="button"
            className={`${styles.tabBtn} ${activeKey === tab.key ? styles.tabBtnActive : ""}`}
            onClick={() => setActiveKey(tab.key)}
          >
            <i className={tab.icon} />
            {tab.label}
          </button>
        ))}
      </div>

      <div className={styles.tabContent}>
        {activeKey === "logs" && (
          <LogsDashboard embedded token={token} onSwitchToUsersTab={() => setActiveKey("users")} />
        )}
        {activeKey === "users" && (
          <UsersDashboard
            embedded
            token={token}
            trialFilterKey={usersTrialFilter}
            trialFilterNonce={filterNonce}
          />
        )}

        <Suspense fallback={<Fallback />}>
          {activeKey === "overview"  && <ExecutiveDashboard embedded token={token} />}
          {activeKey === "customers" && <CustomerDashboard  embedded token={token} />}
          {activeKey === "security"  && <SecurityDashboard  embedded token={token} />}
          {activeKey === "product"   && <ProductDashboard   embedded token={token} />}
        </Suspense>
      </div>
    </div>
  );
}

const mapStateToProps = state => ({
  token: state.auth?.accessToken ?? null
});

export default connect(mapStateToProps)(AdminDashboards);
